import { createContext } from 'react';
const initialModalState = {
    modalComponent: null,
    modalType: null,
    modalId: null,
    isOpen: false,
    showTarget: null,
    hideTarget: null,
    props: {}
};
const ModalContext = createContext(initialModalState);
export default ModalContext;
//# sourceMappingURL=ModalContext.js.map